import React, { useState } from 'react';
import { SupplyPredictionTable } from './SupplyPredictionTable';
import { UnitFilter } from './UnitFilter';
import { TrendAlerts } from './TrendAlerts';
export const PredictionsTab = () => {
  const [selectedUnitId, setSelectedUnitId] = useState('all');
  return <div className="p-6" data-id="element-986">
      <div className="flex justify-between items-center mb-4" data-id="element-987">
        <h2 className="text-xl font-semibold text-gray-900" data-id="element-988">
          Running Estimate Predictions
        </h2>
        <UnitFilter selectedUnitId={selectedUnitId} onUnitChange={setSelectedUnitId} data-id="element-989" />
      </div>
      <p className="text-gray-600 mb-6" data-id="element-990">
        Projected supply levels over the next 120 hours. Resupply scheduled at
        96 hours.
      </p>
      <TrendAlerts data-id="element-991" />
      <SupplyPredictionTable selectedUnitId={selectedUnitId} data-id="element-992" />
    </div>;
};